import { Instagram as IgIcon, Mail, Phone } from "lucide-react";
import { Monogram } from "./Monogram";
import { BotanicalDivider } from "./Botanical";
import { CONTACT } from "../../data/content";

const QUICK_LINKS = [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Our Craft", href: "#process" },
    { label: "Gallery", href: "#gallery" },
    { label: "Kind Words", href: "#testimonials" },
    { label: "FAQ", href: "#faq" },
    { label: "Book a Consultation", href: "#contact" },
];

export const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-gold/20 bg-emerald-deep pb-10 pt-20">
        <div className="mx-auto max-w-6xl px-6 lg:px-10">
            <div className="flex flex-col items-center gap-10 text-center">
                <a href="#top" data-testid="footer-logo-link" aria-label="Back to top">
                    <Monogram size={90} />
                </a>
                <p className="font-script text-3xl text-gold">Where Elegant Moments Begin</p>
                <BotanicalDivider width={280} />

                <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3" data-testid="footer-nav">
                    {QUICK_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="nav-link text-[10px] uppercase tracking-[0.3em] text-ivory/70 hover:text-gold"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-5">
                    <a
                        href={CONTACT.instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-instagram-link"
                        aria-label="Instagram"
                        className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-400 hover:bg-gold hover:text-emerald-deep"
                    >
                        <IgIcon size={18} strokeWidth={1.5} />
                    </a>
                    <a
                        href={`mailto:${CONTACT.email}`}
                        data-testid="footer-email-link"
                        aria-label="Email"
                        className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-400 hover:bg-gold hover:text-emerald-deep"
                    >
                        <Mail size={18} strokeWidth={1.5} />
                    </a>
                    <a
                        href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}
                        data-testid="footer-phone-link"
                        aria-label="Phone"
                        className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-400 hover:bg-gold hover:text-emerald-deep"
                    >
                        <Phone size={18} strokeWidth={1.5} />
                    </a>
                </div>

                <div className="flex flex-col gap-1 text-xs text-ivory/55">
                    <span>{CONTACT.email}</span>
                    <span>
                        {CONTACT.phone} · {CONTACT.instagram}
                    </span>
                </div>

                <div className="mt-4 w-full border-t border-gold/15 pt-6 text-[10px] uppercase tracking-[0.3em] text-ivory/40">
                    © {new Date().getFullYear()} Events by Leemerh — Turning Moments Into Memories
                </div>
            </div>
        </div>
    </footer>
);
